var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    directives: [
      {
        name: "b-tooltip",
        rawName: "v-b-tooltip.left",
        value: _vm.trophyTooltip,
        expression: "trophyTooltip",
        modifiers: { left: true },
      },
    ],
    staticClass: "img-fluid trophy d-xl-block d-none",
    attrs: { src: _vm.trophy, alt: "" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }